import withIcon from './NewIcon';
// @ts-ignore
import IconFilter from './icon/m/filter.s.svg';

export default withIcon(IconFilter);
